import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    SecondaryButton,
    PrimaryButton,
    Container,
    Divider,
    Notice,
    Sanitise,
    UnAuthenticated,
    AsLinkLoginButton,
    Row,
    RegularCard,
    useAuthentication,
    Helmet
} from "@careers-wales/react-components";
import {route} from "../../../routes";
import { Trans } from 'react-i18next';
import ScaleBarGraph from "../../../components/ScaleBarGraph";

import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import config from "../../../config";
import AnalyticsEvent from "../../../components/AnalyticsEvent";
function ResultsView(props) {

    // Hooks.
    const { t, i18n } = useTranslation();
    const { login } = useAuthentication();
    return (
        <Container>
            <Helmet>
                <title>{t('view.results.title')}</title>
            </Helmet>
            <BreadcrumbsItem to={ route('results') }>
                {t('view.results.title')}
            </BreadcrumbsItem>

            <h1>{t('app.name')}</h1>

            {/*{props.saved &&   <Notice type={"info-icon"}>*/}
            {/*    {t('view.results.saved')}*/}
            {/*</Notice>}*/}


            <h2>{t('view.results.title')}</h2>
            <p>{t('view.results.body')}</p>

            <strong>{t('view.results.style.title')}</strong>


            <ScaleBarGraph
                caption={t('view.results.style.tableHeading')}
                xAxisLabel={t('view.results.style.xAxisLabel')}
                xAxisAuto={true}
                data ={ [
                    { name: t('view.results.style.analytical'), url: "#analytical", value: Math.round(props.results.decisionMakingStyle.analytical.score) },
                    { name: t('view.results.style.follower'), url: "#follower",value: Math.round(props.results.decisionMakingStyle.follower.score)   },
                    { name: t('view.results.style.leaveItToChance'), url: "#leaveItToChance",value: Math.round(props.results.decisionMakingStyle.leaveItToChance.score)   },
                    { name: t('view.results.style.listener'), url: "#listener",value: Math.round(props.results.decisionMakingStyle.listener.score)   },
                    { name: t('view.results.style.planner'), url: "#planner",value: Math.round(props.results.decisionMakingStyle.planner.score)   },
                    { name: t('view.results.style.quickToAct'), url: "#quickToAct",value: Math.round(props.results.decisionMakingStyle.quickToAct.score )  },
                    { name: t('view.results.style.researcher'), url: "#researcher",value: Math.round(props.results.decisionMakingStyle.researcher.score )  }
                ].sort((a, b) => b.value - a.value)
            }
            />

            <UnAuthenticated>
                <Notice type={"info-icon"}>
                    <Trans i18nKey={'view.results.signInPrompt'}>
                        <AsLinkLoginButton />
                    </Trans>
                </Notice>
            </UnAuthenticated>

            {props.results.strengths.length > 0 && <>
                <h2>{t('view.results.strengths.title')}</h2>
                <p>{t('view.results.strengths.subtitle')}</p>
                <div className={'style--list-square style--list-no-bg'}>
                    {props.results.strengths.map((item) => {
                        //return <li>{item}</li>
                        return  <Sanitise string={item} />
                    })}
                </div>
            </>}

            {props.results.tipsToImprove.length > 0 && <>
                <h2>{t('view.results.tipsToImprove.title')}</h2>
                <p>{t('view.results.tipsToImprove.subtitle')}</p>
                <div className={'style--list-square style--list-no-bg'}>
                    {props.results.tipsToImprove.map((item) => {
                        return <li>{item}</li>

                    })}
                </div>
            </>}

            {Object.keys(props.results.decisionMakingStyle).sort((a, b) => props.results.decisionMakingStyle[b].score - props.results.decisionMakingStyle[a].score).map((key) => {
                return <>
                    <h2 id={key}>{props.results.decisionMakingStyle[key].name}</h2>
                    <p>{props.results.decisionMakingStyle[key].leadLine}</p>
                    <div className={'style--list-square style--list-no-bg'}>
                        <Sanitise string={props.results.decisionMakingStyle[key].traits}/>
                        <Sanitise string={props.results.decisionMakingStyle[key].tips}/>
                    </div>
                </>
            })}

            <br/>

            <PrimaryButton onPress={props.retakeQuiz} className={"gel-xs-mr-10"}>{t('view.results.reTakeQuiz')}</PrimaryButton>

            <UnAuthenticated>

                <SecondaryButton size={"large"} onPress={login}>{t('view.results.signInToSave')}</SecondaryButton>
            </UnAuthenticated>

            <Divider/>

            <h2>{t('view.results.cards.title')}</h2>
            <Row>
                <RegularCard
                    key={1}
                    width="33"
                    href={t('view.results.cards.0.href')}
                    title={t('view.results.cards.0.title')}
                    source={t('view.results.cards.0.image.src')}
                    alt={t('view.results.cards.0.image.alt')}
                    linkTitle={t('view.results.cards.0.title')}
                >
                    {t('view.results.cards.0.body')}
                </RegularCard>

                <RegularCard
                    key={2}
                    width="33"
                    href={t('view.results.cards.1.href')}
                    title={t('view.results.cards.1.title')}
                    source={t('view.results.cards.1.image.src')}
                    alt={t('view.results.cards.1.image.alt')}
                    linkTitle={t('view.results.cards.1.title')}
                >
                    {t('view.results.cards.1.body')}
                </RegularCard>

                <RegularCard
                    key={3}
                    width="33"
                    href={t('view.results.cards.2.href')}
                    title={t('view.results.cards.2.title')}
                    source={t('view.results.cards.2.image.src')}
                    alt={t('view.results.cards.2.image.alt')}
                    linkTitle={t('view.results.cards.2.title')}
                >
                    {t('view.results.cards.2.body')}
                </RegularCard>
            </Row>

        </Container>
    )
}
export default ResultsView;
